export enum AccessMediaREaderStatusEnum {
    DONE = 'DONE',
    CANCELED = 'CANCELED',
    ERROR = 'ERROR',
    WARNING = 'WARNING'
}